// extracted by mini-css-extract-plugin
export default {"profile-data":"Activity_profile-data__usmyQ","Activity-feed":"Activity_Activity-feed__cVZ9A"};